
























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';

import u from '@/utility/utility';

import ListProduct from './components/ListProduct.vue';
import DeliveryInfo from './components/DeliveryInfo.vue';

import { Product } from '@/models/product';
import { Customer } from '@/models/customer';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import orderService from '@/services/order-service';

@Component({
    components: {
        Loading,
        'list-product': ListProduct,
        'delivery-info': DeliveryInfo
    }
})
export default class AddNewOrder extends Vue {
    private listProducts: any[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;
    private isFragileGoods = false;
    private isFoam = false;
    private isCheckA = false;
    private isCheckB = false;
    private isWechat = false;
    private weChatId = '';
    private guaranteeType = 0;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDiscount() {
        return this.customerLevels.find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get feeGuarantee() {
        // Only get fee guarantee for import orders (IsExport === false)
        const list = this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
        if (!list) return [];
        return list.filter((item: any) => !item.IsExport);
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }

    @Watch('isCheckA', { immediate: true, deep: true })
    private async watchIsCheckA() {
        if (this.isCheckA) {
            this.isCheckB = false;
        }
    }

    @Watch('isCheckB', { immediate: true, deep: true })
    private async watchIsCheckB() {
        if (this.isCheckB) {
            this.isCheckA = false;
        }
    }

    private async created() {
        this.getRate();
        this.getCustomersInfo();
        this.addNewGood();

        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
        if (this.feeGuarantee.length === 0) {
            await this.getFeeGuarantee();
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data
                };
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private async onAddRow(data: any) {
        this.checkValid();
        if (this.listProducts.filter(x => x.isValid === false).length > 0) {
            return false;
        }

        this.addNewGood();
    }

    private async submitOrder() {
        if (!this.checkValid()) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy điền đầy đủ thông tin sản phẩm!',
            });
            return false;
        }

        this.isLoading = true;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            Status: 3,
            ReceivePlaceID: this.customerInfo.ReceivePlaceID,
            ChinaStoreID: this.customerInfo.ChinaStoreID,
            CustomerServiceID: this.customerInfo.CustomerServiceID,
            ExchangeRate: this.rate,
            IsFragileGoods: this.isFragileGoods,
            IsFoam: this.isFoam,
            CheckFeeType: this.isCheckA ? 1 : this.isCheckB ? 2 : 0,
            IsCheck: this.isCheckA || this.isCheckB,
            WechatID: this.isWechat ? this.weChatId : null,
            GuaranteeType: this.guaranteeType,
            Products: [
                ...this.listProducts
            ]
        };

        const result = await orderService.createOrder(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới đơn hàng thành công!',
            });
            this.$router.push({ name: 'order-detail', params: { orderId: result.data.data.ID.toString() } }).catch(() => {
                return false;
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private async onRemoveRow(id: number) {
        this.listProducts = this.listProducts.filter(x => x.id !== id);
    }

    private async addNewGood() {
        const item = new Product();
        this.listProducts.push(item);
    }

    private checkValid() {
        this.listProducts = this.listProducts.map(good => {
            if (u.isNullOrWhitespace(good.title_origin) || u.isNullOrWhitespace(good.quantity) || u.isNullOrWhitespace(good.price_origin)) {
                good.isValid = false;
            } else {
                good.isValid = true;
            }
            return good;
        });

        return !(this.listProducts.filter(x => x.isValid === false).length > 0);
    }
}
